import { createRouter, createWebHistory } from 'vue-router'
import Entrance from '@trust/components/views/Entrance.vue'
// import Stations from '@trust/components/views/Stations.vue'
import PublicOrNah from '@trust/components/views/PublicOrNah.vue'

let orgName = '';

const router = createRouter({
  history: createWebHistory(),
  routes: [
      {
        path: '/entrance',
        component: Entrance,
        name: 'Entrance',
        meta: {
          requiresAuth: false,
          title: orgName + ' Concept Trust',
          enterClass: "animate__animated animate__fadeIn",
          leaveClass: "animate__animated animate__fadeOut",
        }
      },
      {
        path: "/:catchAll(.*)",
        component: PublicOrNah,
        name: 'PublicOrNah',
        meta: {
          requiresAuth: false,
          title: orgName + ' Stations',
          enterClass: "animate__animated animate__fadeIn",
          leaveClass: "animate__animated animate__fadeOut",
        }
      }
  ]
})

// Guard for wallet auth
//
router.beforeEach((to, from, next) => {
  // console.log(to, from, next)
  // next()

  if(router.VueCookieNext.getCookie('token') == null && to.fullPath != "/" && to.name != "Entrance" ) {
    next({ name: 'Entrance', query: { 'to': to.fullPath }})
  } else {
    if(to.name != 'Entrance'){
      let activeTrust = to.fullPath.split('/')[1];
      router.store.commit('setActiveTrust', { activeTrust });
    }
    router.store.dispatch('routing/navigate', to);
    next();
  }

  // if(router.VueCookieNext.getCookie('token') == null) {
  //   // doesn't have cookie
  //   console.log('no cookie with fullPath: ', to.fullPath)
  //   if(to.fullPath == "/"){
  //     next({ name: 'PublicOrNah' })
  //   } else {
  //     next({ name: 'Entrance', query: { 'to': to.fullPath }})
  //   }
  // } else {
  //   console.log('has cookie with fullPath: ', to.fullPath)
  //   // has cookie
  //   // router.store.dispatch('routing/navigate', to);
  //   // next({ name: 'PublicOrNah' })
  //   next()
  // }


  // // Going to auth'd route
  // if (to.meta.requiresAuth && router.VueCookieNext.getCookie('token') == null) {
  //   console.log('to: ', to)
  //   console.log('Not logged in ')
  //   if(to.fullPath == "/"){
  //     next({ name: 'PublicOrNah' })
  //   } else {
  //     // do something about logging in
  //     next({ name: 'Entrance', query: { 'to': to.fullPath }})
  //   }
  //
  // // Going to Public
  // } else if (to.name == 'Public' && router.VueCookieNext.getCookie('token') != null) {
  //   console.log('Public but logged in ')
  //   next({ name: 'PublicOrNah' })
  //
  // // Going to Entrance
  // } else if (to.name == 'Entrance' && router.VueCookieNext.getCookie('token') != null) {
  //   console.log('Entrance but logged in ')
  //   next({ name: 'PublicOrNah' })
  //
  // // When tf does this get hit
  // } else {
  //   console.log('HIT ELSE IN ROUTER')
  //   if(router.VueCookieNext.getCookie('token') == null) {
  //     next({ name: Entrance })
  //   } else {
  //     router.store.dispatch( 'routing/navigate', to);
  //     next()
  //   }
  // }
})

export default router;
